import * as rq from '@tanstack/react-query';
import { z } from 'zod';

import { MetadataSchema } from '../entities/metadata';

import { getMetadata } from './__mocked_data__/metadata-state';

export namespace UsermanagementMetadataQuery {
  export const key = () => ['user-management', 'usermanagement-metadata'];

  export const OutputSchema = MetadataSchema;
  export type Output = z.infer<typeof OutputSchema>;

  function outputMapper(): Output {
    return getMetadata();
  }

  function useQueryFn() {
    return async function queryFn() {
      const output = await OutputSchema.parseAsync(outputMapper());
      return output;
    };
  }

  export function useQuery() {
    const queryFn = useQueryFn();

    return rq.useQuery<Output>({
      queryKey: key(),
      queryFn: () => queryFn(),
    });
  }

  export function usePrefetch() {
    const queryClient = rq.useQueryClient();
    const queryFn = useQueryFn();

    return async function prefetch(): Promise<void> {
      await queryClient.prefetchQuery<Output>({
        queryKey: key(),
        queryFn: () => queryFn(),
      });
    };
  }
}
